import { Injector } from '@wendellhu/redi';
import type { Dependency } from '@wendellhu/redi';

export interface ModuleDeclaration {
  providers: Dependency[];
  imports?: ModuleDeclaration[];
}

const collectProviders = (
  mod: ModuleDeclaration,
  seen: WeakSet<ModuleDeclaration>,
): Dependency[] => {
  if (seen.has(mod)) {
    return [];
  }

  seen.add(mod);

  const result: Dependency[] = [];
  for (const imported of mod.imports ?? []) {
    result.push(...collectProviders(imported, seen));
  }
  result.push(...mod.providers);

  return result;
};

export function createAppInjector(
  rootModule: ModuleDeclaration,
  parentInjector?: Injector,
): Injector {
  const deps = collectProviders(rootModule, new WeakSet());
  return parentInjector ? parentInjector.createChild(deps) : new Injector(deps);
}
